import {combineReducers} from "redux";
import SurveyConst from "./SurveyConst";

const data = (state={age: "", gender: "", hasDegree: "", degree: "", nativeLanguage: "", language:"", tests:"", feedbackText:""}, action=null) => {
  switch(action.type){
    //case SurveyConst.SET_AGE:
      //  return Object.assign({},state, {age: action.payload})
      //case SurveyConst.SET_GENDER:
      //  return Object.assign({},state, {gender: action.payload})
      //case SurveyConst.SET_HAS_DEGREE:
      //  return Object.assign({},state, {hasDegree: action.payload})
      //case SurveyConst.SET_DEGREE:
      //  return Object.assign({},state, {degree: action.payload})
      //case SurveyConst.SET_LANGUAGE_NATIVE:
      //  return Object.assign({},state, {nativeLanguage: action.payload})
      //case SurveyConst.SET_LANGUAGE:
      //  return Object.assign({},state, {language: action.payload})
      //case SurveyConst.SET_TESTS:
      //  let str = "";
      //  if(state.tests.indexOf(action.payload) > -1){
        //    let index = state.tests.indexOf(action.payload);
        //    let substr1= state.tests.substring(0, index);
        //    let substr2 = state.tests.substring(index+1, state.tests.length);
        //    str = substr1 + substr2;
        //  }else{
        //    str = state.tests + action.payload;
        //    console.log(str);
        //  }
      //  return Object.assign({},state, {tests: str});
      //case SurveyConst.SET_FEEDBACK_TEXT:
      //  return Object.assign({},state, {feedbackText: action.payload})
    case SurveyConst.SET_SURVEY_VALUE:
      let nState = Object.assign({}, state)
      if(action.payload.name === "tests"){
        if(nState.tests.indexOf(action.payload.value) > -1){
          nState.tests = nState.tests.replace(action.payload.value, "")
        }else{
          nState.tests = nState.tests + action.payload.value
        }
      }else{
        nState[action.payload.name] = action.payload.value
      }
        return nState
    default:
      return state
  }
}

const surveyClick = (state={clicked: 0}, action=null) => {
  switch (action.type){
    case SurveyConst.SURVEY_CLICK:
      return Object.assign({}, state, {clicked: state.clicked + 1})
    default:
      return state
  }
}

const displaySurvey = (state={display: true}, action=null) => {
  switch(action.type){
    case SurveyConst.TRIGGER_SURVEY_FORM:
      return Object.assign({},state,{display:!state.display})
    default:
      return state;
  }
}

const displayThanks = (state={thanks: false}, action=null) => {
  switch(action.type){
    case SurveyConst.SAVE_SURVEY:
      if(action.payload.success || action.payload.clicked === 0)
        return Object.assign({},state, {thanks:true})
      return state;
    default:
        return state;
  }
}

const survey = combineReducers({data, displaySurvey, displayThanks, surveyClick});
export {survey};



// WEBPACK FOOTER //
// ./src/modules/survey/SurveyReducer.js